import type { ColumnDef } from "@kontextwerk/web-sdk/ui/layout/Table.svelte"

export const customerTableColumns: ColumnDef[] = [
  {
    id: "identityLabel",
    label: "Kontakt",
    tooltip: "Name des Ansprechpartners mit Typ.",
    sortable: true,
    sortKey: "name",
    sortType: "text",
  },
  {
    id: "contactValue",
    label: "Kontaktdaten",
    tooltip:
      "Kontaktwege des Ansprechpartners. Details zu Herkunft und Fachprogramm-Abgleich stehen im Tooltip.",
    sortable: true,
    sortKey: "contact",
    sortType: "text",
  },
  {
    id: "roleValues",
    label: "Rollen",
    tooltip: "Rollen aus den Liegenschafts- und Einheitenzuordnungen.",
    sortable: false,
  },
  {
    id: "objectEntries",
    label: "Einheit",
    tooltip: "Mit dem Ansprechpartner verbundene Einheit und zugehörige Liegenschaft.",
    sortable: true,
    sortKey: "address",
    sortType: "text",
  },
]
